import { render, staticRenderFns } from "./SVButton.vue?vue&type=template&id=577bfa09&scoped=true"
import script from "./SVButton.vue?vue&type=script&lang=ts"
export * from "./SVButton.vue?vue&type=script&lang=ts"
import style0 from "./SVButton.vue?vue&type=style&index=0&id=577bfa09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "577bfa09",
  null
  
)

export default component.exports